import React, { } from 'react'
import './MainBanner.scss'
import mainBanner from '../../assets/home/main-banner.png'

const MainBanner: React.FC = () => {
    return(
        <div className='MainBanner' style={{background: `linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)), url(${mainBanner}) no-repeat`}}>
            <div className="title">IT and Web solutions for your business</div>
            <button className='button primary-button'>Get Contact</button>
        </div>
    )
}

export default MainBanner

